'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      var bodyClasses = 'page-template-default page page-id-1320 l-body Impreza_4.9.1 HB_2.0.4 header_hor header_inpos_top btn_hov_slide state_default tribe-js wpb-js-composer js-comp-ver-5.4.5 vc_responsive';

      return _react2.default.createElement(
        _reactBodyClassname2.default,
        { className: bodyClasses },
        _react2.default.createElement(
          'div',
          { className: 'Header l-canvas sidebar_none type_wide' },
          _react2.default.createElement(
            'header',
            { className: 'l-header pos_fixed bg_transparent shadow_thin', itemScope: true, itemType: 'https://schema.org/WPHeader' },
            _react2.default.createElement(
              'div',
              { className: 'l-subheader at_middle' },
              _react2.default.createElement(
                'div',
                { className: 'l-subheader-h' },
                _react2.default.createElement(
                  'div',
                  { className: 'l-subheader-cell at_left' },
                  _react2.default.createElement(
                    'div',
                    { className: 'w-img with_transparent ush_image_2' },
                    _react2.default.createElement(
                      'a',
                      { className: 'w-img-h', href: 'http://www.economiesocialelaval.com/' },
                      _react2.default.createElement('img', { alt: 'PRES', className: 'for_default', height: 135, src: 'http://www.economiesocialelaval.com/nouveausite/wp-content/uploads/2017/10/logo-PRES.jpg', width: 257 }),
                      _react2.default.createElement('img', { alt: true, className: 'for_transparent', height: 135, src: 'http://www.economiesocialelaval.com/nouveausite/wp-content/uploads/2017/10/logo-PRES-trans.png', width: 257 })
                    )
                  )
                ),
                _react2.default.createElement('div', { className: 'l-subheader-cell at_center' }),
                _react2.default.createElement(
                  'div',
                  { className: 'l-subheader-cell at_right' },
                  _react2.default.createElement(
                    'nav',
                    { className: 'w-nav height_full dropdown_height m_align_left m_layout_dropdown ush_menu_1 type_desktop', itemScope: true, itemType: 'https://schema.org/SiteNavigationElement' },
                    _react2.default.createElement(
                      'a',
                      { 'aria-label': 'Menu', className: 'w-nav-control', href: '#' },
                      _react2.default.createElement(
                        'div',
                        { className: 'w-nav-icon' },
                        _react2.default.createElement('i', null)
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        'Menu'
                      )
                    ),
                    _react2.default.createElement(
                      'ul',
                      { className: 'w-nav-list level_1 hover_simple' },
                      _react2.default.createElement(
                        'li',
                        { className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children w-nav-item level_1 menu-item-1334 togglable', id: 'menu-item-1334' },
                        _react2.default.createElement(
                          'a',
                          { className: 'w-nav-anchor level_1', href: 'http://www.economiesocialelaval.com/pole-regionale/' },
                          _react2.default.createElement(
                            'span',
                            { className: 'w-nav-title' },
                            '\xC0 propos'
                          ),
                          _react2.default.createElement('span', { className: 'w-nav-arrow' })
                        ),
                        _react2.default.createElement(
                          'ul',
                          { className: 'w-nav-list level_2' },
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1499', id: 'menu-item-1499' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/pole-regionale/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'P\xF4le r\xE9gional d\u2019\xE9conomie social de Laval'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1503', id: 'menu-item-1503' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/equipe/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                '\xC9quipe'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1681', id: 'menu-item-1681' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/partenaires/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Partenaires'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1510', id: 'menu-item-1510' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/leconomie-sociale-a-laval/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'L\u2019\xE9conomie sociale \xE0 Laval'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        { className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children w-nav-item level_1 menu-item-1328 togglable', id: 'menu-item-1328' },
                        _react2.default.createElement(
                          'a',
                          { className: 'w-nav-anchor level_1', href: 'http://www.economiesocialelaval.com/membres/' },
                          _react2.default.createElement(
                            'span',
                            { className: 'w-nav-title' },
                            'Membres'
                          ),
                          _react2.default.createElement('span', { className: 'w-nav-arrow' })
                        ),
                        _react2.default.createElement(
                          'ul',
                          { className: 'w-nav-list level_2' },
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1518', id: 'menu-item-1518' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/membres/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Membres'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1519', id: 'menu-item-1519' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/ils-sont-membre/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Ils sont membre'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        { className: 'menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-1320 current_page_item w-nav-item level_1 menu-item-1329', id: 'menu-item-1329' },
                        _react2.default.createElement(
                          _reactRouter.IndexLink,
                          { to: '/', className: 'w-nav-anchor level_1' },
                          _react2.default.createElement(
                            'span',
                            { className: 'w-nav-title' },
                            '\xC9v\xE8nements'
                          ),
                          _react2.default.createElement('span', { className: 'w-nav-arrow' })
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        { className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children w-nav-item level_1 menu-item-1793 togglable', id: 'menu-item-1793' },
                        _react2.default.createElement(
                          'a',
                          { className: 'w-nav-anchor level_1', href: 'http://*' },
                          _react2.default.createElement(
                            'span',
                            { className: 'w-nav-title' },
                            'Ressources'
                          ),
                          _react2.default.createElement('span', { className: 'w-nav-arrow' })
                        ),
                        _react2.default.createElement(
                          'ul',
                          { className: 'w-nav-list level_2' },
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1841', id: 'menu-item-1841' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/emplois/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Emplois'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1791', id: 'menu-item-1791' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/formation/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Formations'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        { className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children w-nav-item level_1 menu-item-1331 togglable', id: 'menu-item-1331' },
                        _react2.default.createElement(
                          'a',
                          { className: 'w-nav-anchor level_1', href: 'http://www.economiesocialelaval.com/lab-dinnovation-sociale/' },
                          _react2.default.createElement(
                            'span',
                            { className: 'w-nav-title' },
                            'Lab d\u2019innovation sociale'
                          ),
                          _react2.default.createElement('span', { className: 'w-nav-arrow' })
                        ),
                        _react2.default.createElement(
                          'ul',
                          { className: 'w-nav-list level_2' },
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1530', id: 'menu-item-1530' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/lab-dinnovation-sociale/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Lab d\u2019innovation sociale'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1529', id: 'menu-item-1529' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/generatrice-dinnovation-sociale/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'G\xE9n\xE9ratrice d\u2019innovation sociale'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_1 menu-item-1716', id: 'menu-item-1716' },
                        _react2.default.createElement(
                          'a',
                          { className: 'w-nav-anchor level_1', href: 'http://www.economiesocialelaval.com/nouvelles/' },
                          _react2.default.createElement(
                            'span',
                            { className: 'w-nav-title' },
                            'Nouvelles'
                          ),
                          _react2.default.createElement('span', { className: 'w-nav-arrow' })
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        { className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children w-nav-item level_1 menu-item-1570 togglable', id: 'menu-item-1570' },
                        _react2.default.createElement(
                          'a',
                          { className: 'w-nav-anchor level_1', href: 'http://*' },
                          _react2.default.createElement(
                            'span',
                            { className: 'w-nav-title' },
                            'M\xE9diath\xE8que'
                          ),
                          _react2.default.createElement('span', { className: 'w-nav-arrow' })
                        ),
                        _react2.default.createElement(
                          'ul',
                          { className: 'w-nav-list level_2' },
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1732', id: 'menu-item-1732' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/bottin/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Bottin'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1737', id: 'menu-item-1737' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/rapports-annuels/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Rapports annuels'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1735', id: 'menu-item-1735' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/memoires/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'M\xE9moires'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1734', id: 'menu-item-1734' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/communiques/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Communiqu\xE9s'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1736', id: 'menu-item-1736' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/videotheque/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Videoth\xE8que'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          ),
                          _react2.default.createElement(
                            'li',
                            { className: 'menu-item menu-item-type-post_type menu-item-object-page w-nav-item level_2 menu-item-1733', id: 'menu-item-1733' },
                            _react2.default.createElement(
                              'a',
                              { className: 'w-nav-anchor level_2', href: 'http://www.economiesocialelaval.com/autres-documents/' },
                              _react2.default.createElement(
                                'span',
                                { className: 'w-nav-title' },
                                'Autres documents'
                              ),
                              _react2.default.createElement('span', { className: 'w-nav-arrow' })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'li',
                        { style: { listStyle: 'none', display: 'inline' } },
                        _react2.default.createElement('div', { className: 'w-nav-close' })
                      )
                    ),
                    _react2.default.createElement('div', { className: 'w-nav-options hidden', onClick: function onClick() {
                        return { mobileWidth: 900, mobileBehavior: 1 };
                      } })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'w-search layout_fullscreen ush_search_1' },
                    _react2.default.createElement('div', { className: 'w-search-background' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'w-search-form' },
                      _react2.default.createElement(
                        'form',
                        { action: 'http://www.economiesocialelaval.com/', autoComplete: 'off', className: 'w-search-form-h', method: 'get' },
                        _react2.default.createElement(
                          'div',
                          { className: 'w-search-form-field' },
                          _react2.default.createElement('input', { 'aria-label': 'Recherche', id: 'us_form_search_s', name: 's', placeholder: 'Recherche', type: 'text' }),
                          _react2.default.createElement('span', { className: 'w-form-row-field-bar' })
                        ),
                        _react2.default.createElement('div', { className: 'w-search-close' })
                      )
                    ),
                    _react2.default.createElement('a', { 'aria-label': 'Recherche', className: 'w-search-open', href: '#' })
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: 'l-subheader for_hidden hidden' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'l-main' },
            _react2.default.createElement(
              'div',
              { className: 'l-main-h i-cf' },
              _react2.default.createElement(
                'main',
                { className: 'l-content', itemProp: 'mainContentOfPage' },
                _react2.default.createElement(
                  'section',
                  { className: 'l-section wpb_row height_auto width_full' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement('img', { alt: true, height: 700, src: 'http://www.economiesocialelaval.com/nouveausite/wp-content/uploads/2017/12/slider-image-2500x900-00008.jpg', width: 2500 }),
                    _react2.default.createElement(
                      'div',
                      null,
                      '\xC9v\xE8nements'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Header;
}(_react.Component);

exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header.js
// module id = 1144
// module chunks = 0